<template>
    <div id="loginPage" class="text-center">
        <v-card style="width: 90%; max-width: 500px;" class="pa-10" rounded="xl">
            <Logo  width="128px" :height="'128px'" theme="light" />
            <h3 class="font-weight-bold">منصة نور التعليمية</h3>
            <small>رحلتك الى المستقبل</small>
            <v-text-field class="mt-5" @keypress.enter="login()" prefix="nooor.app@" prepend-inner-icon="mdi-email-outline"
                variant="outlined" label="البريد الالكتروني" v-model="loginCredintials.email"></v-text-field>
            <v-text-field @keypress.enter="login()" class="mb-5" prepend-inner-icon="mdi-lock-outline"
                variant="outlined" label="كلمة المرور" v-model="loginCredintials.password"
                type="password"></v-text-field>
            <v-btn class="mb-2" :loading="loginLoading" @click="login()" :elevation="0" size="large" rounded
                color="primary" block>
            <span class="text-white">تسجيل الدخول</span>
            </v-btn>
        </v-card>
        <div class="text-white mt-5 loginCopyrights">
            <b>Nooor Educational Platform v{{ require('../../package.json').version }}</b>
            <br>
            <b>Nooor.app &copy; {{ new Date().getFullYear() }}</b>
        </div>
    </div>
</template>

<script>
import Logo from '../components/Logo.vue';

export default {
    data: () => ({
        loginLoading: false,
        loginCredintials: {
            email: '',
            password: ''
        }
    }),
    components: {
        Logo
    },
    methods: {
        async login() {
            this.loginLoading = true;
            this.$axios.post('auth/login', {
                email: this.loginCredintials.email.toLowerCase() + "@nooor.app",
                password: this.loginCredintials.password,
            }).then(async res => {
                localStorage.setItem("userInfo", JSON.stringify(res.data));
                localStorage.setItem("token", res.data.data.access_token);
                localStorage.setItem("refresh", res.data.data.refresh_token);
                await this.$axios.patch('users/me', {
                    last_otp: null,
                });
                window.location.reload();
            }).catch(() => {
                this.$toast.error("المعلومات غير صحيحة");
            }).finally(() => {
                this.loginLoading = false;
            })
        }
    }
}
</script>

<style scoped>
#loginPage {
    background-color: rgb(var(--v-theme-info));
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.loginCopyrights {
    text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.422);
}
</style>